export const typeDefs = `
  union DepositHistorySortType = date | trxId | status | amount

  input DepositHistoryFilterInput {
    date: [String]
    trxId: [String]
    status: String
    amount: [String]
  }

  input LoanPlanInputMutation {
    accessToken: String!
    idToken: String!
    userName: String!
    planId: String!
  }

  union LoanHistorySortType = date | trxId | status | amount | userName

  input LoanHistoryFilterInput {
    date: [String]
    trxId: [String]
    status: String
    amount: [String]
    userName: [String]
  }
`;
